import { useCallback } from "react";
import { usePathname } from "next/navigation";
import { PropertyDataFromBooking, PropertyTypeV2 } from "commonModule/services/common";
import GuestPopoverInDetailBooking from "components/searchBar/GuestPopoverDetailBooking";
import { useWindowScrolledMoreThan } from "hooks/useWindowScrolledMoreThan";
import { mixpanelV2Client } from "services/mixpanelv2";
import { markBookingStore, selectBookingStore } from "stores/booking/bookingSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { selectMultiUnitStore } from "stores/multi-unit-detail/multiUnitSlice";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
import { createSearchURL, ensembleCityStateCountry } from "utils/url";
export const handleGuestValue = (x: {
  adult: number;
  child: number;
  pets: boolean;
  petNumber: number;
}) => {
  const totalGuests = x.adult + x.child;
  const petsText = x.pets ? x.petNumber === 0 ? " & pet" : x.petNumber === 1 ? " & 1 pet" : ` & ${x.petNumber} pets` : "";
  return totalGuests === 1 ? `1 Guest${petsText}` : totalGuests > 1 ? `${totalGuests} Guests${petsText}` : "Add guests";
};
export const GuestModule = ({
  property,
  displayAllInPricing = false
}: {
  property: PropertyTypeV2 | PropertyDataFromBooking;
  displayAllInPricing?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const bookingStore = useAppSelector(selectBookingStore);
  const pathname = usePathname();
  const isPaymentPage = pathname?.startsWith("/payment");
  const isDetailsPage = pathname?.startsWith("/detail");
  const [isLargerThan456] = useMediaQuery("(min-width: 456px)");
  const [isMobile] = useMediaQuery("(max-width: 767px)");
  const scrolled = useWindowScrolledMoreThan(112);
  const multiUnits = useAppSelector(selectMultiUnitStore);
  const applyGuestInputHandler = useCallback((res: {
    adult: number;
    child: number;
    pets: boolean;
    petNumber: number;
  }) => {
    mixpanelV2Client?.GUEST_SELECTION({
      adultCount: res?.adult || multiUnits.adultCount || 1,
      childCount: res?.child || multiUnits.childrenCount || 0,
      petAllowed: res?.pets || multiUnits.petAllowed || false,
      pageOrigin: "checkout payment page"
    });
    dispatch(markBookingStore({
      adultNumber: res.adult,
      childNumber: res.child,
      pet: res.pets || res.petNumber > 0,
      petNumber: res.petNumber
    }));
  }, [dispatch]);
  const clearGuestInputHandler = useCallback(() => {
    dispatch(markBookingStore({
      adultNumber: 1,
      childNumber: 0,
      pet: false,
      petNumber: 0
    }));
  }, [dispatch]);
  const placeURL = `/vacation-rentals/${createSearchURL(ensembleCityStateCountry({
    city: property.city,
    state: property.state,
    country: property.country
  }))}?petAllowed=true`;
  return <div className={`${isLargerThan456 || !isDetailsPage ? "w-full" : ""} ${isDetailsPage && isLargerThan456 ? `relative p-0` : ""}`} data-sentry-component="GuestModule" data-sentry-source-file="GuestModule.tsx">
      {/* On payment page, show only when not mobile and on other pages, show only when isLargerThan456 */}
      {(isPaymentPage && !isMobile || !isPaymentPage && isLargerThan456) && <p className={`pb-1 text-left leading-[17px] ${isDetailsPage || displayAllInPricing ? "hidden" : "text-sm"} ${isPaymentPage ? "font-semibold text-textColor md:font-medium md:text-[#606161]" : "font-medium"}`}>
          Guests
        </p>}
      <GuestPopoverInDetailBooking initalState={{
      adultCount: bookingStore.adultNumber || 1,
      childCount: bookingStore.childNumber || 0,
      petsAllowed: bookingStore.pet || false,
      petNumber: bookingStore.petNumber || 0
    }} maxGuestCount={property.max_no_guests || 16} petAllowed={property.suitable_pet || false} childAllowed={property.suitable_child || false} maxPetsCount={property.max_pet_count || 0} minimumAge={property.minimum_age} isDetailPage={true} onClear={clearGuestInputHandler} onApply={res => applyGuestInputHandler(res)} placeURL={placeURL} data-sentry-element="GuestPopoverInDetailBooking" data-sentry-source-file="GuestModule.tsx">
        {currentState => <span className={`btn w-full rounded-lg bg-transparent ${isDetailsPage ? `!h-[13px] text-xs font-medium text-Gray-700 underline xsm:text-[13px] md:!h-[15.6px]` : !isPaymentPage ? "text-base font-medium text-textColor" : ""} ${isDetailsPage ? "h-7 justify-start p-0  " : !isPaymentPage ? "h-12 justify-start px-2.5 lg:justify-center lg:border lg:border-[#999A9A] lg:p-2" : ""} ${isPaymentPage ? ` h-4 justify-start p-0 text-sm font-medium text-[#717171] md:h-7 md:text-[13px] md:text-textColor ${scrolled ? "md:underline" : "underline"}` : ""}`}>
            {handleGuestValue(currentState)}
          </span>}
      </GuestPopoverInDetailBooking>
    </div>;
};